module.exports = __webpack_public_path__ + "img/tp-card-blank-amex.43f51e4c.png";